/*
 * Layout Name: About Banner
 * Desc:
 */
// libs
import React from "react"
import ReactMarkdown from "react-markdown"
// assets
import * as styles from "./AboutBanner.module.scss"
import Button from "@components/objects/Button/Button"
import Section from "@components/structure/Section/Section"
// components
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"

const AboutBanner = ({ banner }) => {
  const text = banner[0].markdown
  const buttonLabel = banner[1].label

  console.log("banner")
  console.log(banner)

  return (
    <section className={styles.AboutBanner}>
      <Section>
        <SiteWrapper className={styles.wrapper}>
          <ReactMarkdown>{text}</ReactMarkdown>
          <Button text={buttonLabel} link="/onboarding" color="pink" className={styles.button} />
        </SiteWrapper>
      </Section>
    </section>
  )
}

export default AboutBanner
